export default __webpack_public_path__ + "static/events-dark-f8f0e97a59dea44e420623a4173c8af6.png";